import { CJLogo } from "@cjdev-internal/visual-stack-x/CJLogo";
import { Row } from "@cjdev-internal/visual-stack-x/Row";
import { Stack } from "@cjdev-internal/visual-stack-x/Stack";
import { Text } from "@cjdev-internal/visual-stack-x/Text";
import { FormModal, useIntl } from "@platform/cj-platform-navigation";
import { ExternalLink } from "components/ExternalLink";
import messages from "components/InfluencerSignupLayout/messages";
import { useAdvertiserBrandedInfo } from "hooks/useAdvertiserBrandedInfo";
import { useResolveBrandedSignupPage } from "hooks/useResolveBrandedSignupPage";

export const InfluencerOnboardingWrapper = ({
  advertiserId,
  pageId,
  children,
}) => {
  const { formatMessage } = useIntl();
  const {
    data: advertiserBrandedInfo,
    isInitialLoading: isLoadingAdvertiserBrandedInfo,
  } = useAdvertiserBrandedInfo(advertiserId);
  const {
    data: bspData,
    isInitialLoading: isLoadingBrandedSignupPage,
  } = useResolveBrandedSignupPage(pageId);

  const loading = isLoadingAdvertiserBrandedInfo || isLoadingBrandedSignupPage;

  const bsp = bspData?.data?.resolveBrandedSignupPage;

  const logoUrl = bsp
    ? bsp.logoImage?.url
    : advertiserBrandedInfo
    ? `https://signup.cj.com/member/publisher/logo/${advertiserBrandedInfo?.smallLogoId}`
    : null;

  const name = bsp ? bsp.campaignName : advertiserBrandedInfo?.name;

  return (
    <FormModal
      isOpen
      logo={
        loading || !logoUrl ? (
          <></>
        ) : (
          <img
            style={{ maxHeight: "32px" }}
            alt={`${name} logo`}
            src={logoUrl}
          />
        )
      }
      title={loading || !name ? <></> : `${name} Affiliate Program`}
    >
      <Stack
        expand
        justify="space-between"
        style={{ height: "calc(100vh - 56px)" }}
      >
        {children}
        <Row
          padding="2xl"
          align="end"
          justify="space-between"
          className="footer"
        >
          <Row gap="medium">
            <CJLogo size="small" />
            <Stack>
              {name && (
                <Text weight="medium">
                  {formatMessage(messages.byJoining, [name])}
                </Text>
              )}
              <Text>{formatMessage(messages.signing)}</Text>
              <Text>
                <ExternalLink href="https://www.cj.com/publisher">
                  {formatMessage(messages.learn)}
                </ExternalLink>
              </Text>
            </Stack>
          </Row>
          <Row gap="large">
            <Text color="secondary">
              &copy; {new Date().getFullYear()} Commission Junction LLC
            </Text>
            <ExternalLink href="https://www.cj.com/legal/privacy">
              <Text color="secondary">{formatMessage(messages.privacy)}</Text>
            </ExternalLink>
            <ExternalLink href="https://www.cj.com/support-center">
              <Text color="secondary">{formatMessage(messages.support)}</Text>
            </ExternalLink>
          </Row>
        </Row>
      </Stack>
    </FormModal>
  );
};
